<template>
  <el-dialog
      :visible.sync="dialogVisible"
      append-to-body
      title="选择物料"
      class="customer-edit"
      width="80%"
      top="5vh">
    <vm-table
        ref="vmTable"
        :filter.sync="filter"
        module="basic"
        url="sapBaseMaterials">
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="物料编号">
            <el-input v-model.trim="filter.no" clearable/>
          </vm-search>
          <vm-search label="物料名称">
            <el-input v-model.trim="filter.name" clearable/>
          </vm-search>
          <vm-search label="物料组">
            <el-input v-model.trim="filter.materialGroupNO" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="no" label="物料编号"/>
      <el-table-column prop="name" label="物料描述"/>
      <el-table-column prop="materialGroupNO" label="物料组"/>
      <el-table-column prop="productGroupNO" label="产品组"/>
      <el-table-column prop="purchaseGroupNO" label="采购组"/>
      <el-table-column label="操作" align="center" width="120px">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="onSelect(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </vm-table>
  </el-dialog>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";


  export default {
    name: "MaterialCSSelect",
    components: {VmTable, VmSearch},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        idList: "",
        index: 0,
        filter: {
          supplierInfoId: "",
          no: "",
          name: "",
          materialGroupNO: "",
        },
      };
    },
    methods: {
      open(index) {
        this.dialogVisible = true;
        this.index = index;
        this.$nextTick(() => {
          this.$refs.vmTable.getList(1);
        });
      },
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      onSelect(row) {
        this.$emit("select", row, this.index);
        this.dialogVisible = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
